import React from "react";
import { Link } from "react-router-dom";
import { cropText } from "./cropText";

/**
 * CropStoryCard — tile used in the /crops and /wiki index grids.
 * `to` lets the same card link to either the story page or the wiki page.
 */
export default function CropStoryCard({ crop, lang = "EN", to }) {
  const isAr = lang === "AR";
  const href = to || `/crops/${crop.slug}`;

  return (
    <Link
      to={href}
      dir={isAr ? "rtl" : "ltr"}
      className="group block rounded-xl border border-gray-200 bg-white overflow-hidden shadow-sm hover:shadow-md transition"
    >
      <div className="h-40 bg-emerald-50 flex items-center justify-center overflow-hidden">
        <img
          src={crop.image}
          alt={cropText(crop.name, lang)}
          className="object-cover w-full h-full group-hover:scale-105 transition"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </div>
      <div className="p-4">
        <h3 className="text-lg font-semibold text-gray-900">
          {cropText(crop.name, lang)}
        </h3>
        <p className="text-xs text-gray-500 italic">{crop.scientificName}</p>
        <p className="mt-2 text-sm text-gray-600 line-clamp-3">
          {cropText(crop.story.lead, lang)}
        </p>
        <span className="mt-3 inline-block text-sm font-medium text-emerald-700 group-hover:underline">
          {isAr ? "اعرف المزيد ←" : "Explore →"}
        </span>
      </div>
    </Link>
  );
}
